import { Component, OnInit, ViewChild, AfterViewInit, ElementRef} from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'

export interface CommentModel {
  title: string;
  message: string;
  canExit: boolean;
  blocking: boolean;
}

@Component({
  selector: 'gridedit',
  template: `<div class="modal-dialog">
                <div class="modal-content">
                   <div class="modal-header">
                   <h4 class="modal-title">{{title || 'Document Upload'}}</h4>
                   </div>
                   <form [formGroup]="form" (ngSubmit)="onSave()" >
                   <div class="modal-body">
                   <!--<div *ngIf="blocking">
                   <h6><label>Block/Complete</label></h6>
                   <select class="form-control" formControlName="INPUT" type="text" [(ngModel)]="option">
                    <option selected="true" disabled="disabled">Select One</option>
                    <option>Block</option>
                    <option>Complete</option>
                   </select>
                   </div>-->
                   <label>{{message || 'Please enter text'}}</label>
                     <textarea rows="3" cols="40" name="INPUT" formControlName="INPUT" class="form-control" [(ngModel)]="data"></textarea>
                   </div>
                   <div class="modal-footer">
                   <button *ngIf="canExit" type="button" (click)="onCancel()" class="btn btn-primary btn-md" style="width:30%"><i class="fa fa-arrow-circle-left"></i> Cancel</button>
                     <button type="submit" class="btn btn-success btn-md" style="width:30%"[disabled]="!form.valid" #setfocus><i class="fa fa-save"></i> Save</button>
                   </div>
                   </form>
                </div>
             </div>`
})
export class CommentComponent extends DialogComponent<CommentModel, string> implements CommentModel {
  title: string;
  message: string;
  canExit = false;
  data = '';
  blocking: boolean;
  option = '';

  form: UntypedFormGroup;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      INPUT: new UntypedFormControl('', Validators.required)
    });
  }

  onSave() {
      this.result = this.data; //`${this.option}<->${this.data}`;
    this.close();
  }

  onCancel() {
    this.result = null;
    this.close()
  }

  @ViewChild('setfocus', { static: true }) private elementref: ElementRef
  public ngAfterViewInit(): void {
    this.elementref.nativeElement.focus();
  }

  private inputFocused = false;
  moveFocus() {
      this.inputFocused = true;
      setTimeout(() => {this.inputFocused = false});
  }


}
